import React, { useState, useEffect, useRef } from 'react';

const FALLBACK_DATA = [
  { category: 'Global Luxury Tokenization', value: '$27.65B', change: '+4.1% M/M', sentiment: 'positive' },
  { category: 'Fine Art Index', value: 'Bullish', change: '+2.4%', sentiment: 'positive' },
  { category: 'Vintage Automotive Market', value: 'Stable', change: '', sentiment: 'neutral' },
  { category: 'Supercars & Hypercars', value: 'Bullish', change: '+3.6%', sentiment: 'positive' },
  { category: 'Rare Spirit Yield', value: '', change: '+5.2%', sentiment: 'positive' },
];

export const SentinelTicker = () => {
  const [data, setData] = useState(FALLBACK_DATA);
  const trackRef = useRef(null);

  useEffect(() => {
    fetchTickerData();
    const interval = setInterval(fetchTickerData, 60000);
    return () => clearInterval(interval);
  }, []);

  const fetchTickerData = async () => {
    try {
      const API = process.env.REACT_APP_BACKEND_URL;
      const res = await fetch(`${API}/api/market/sentinel-ticker`);
      if (res.ok) {
        const items = await res.json();
        if (Array.isArray(items) && items.length > 0) {
          setData(items);
        }
      }
    } catch {
      // Keep fallback data on error
    }
  };

  // Duplicate items for seamless loop
  const items = [...data, ...data, ...data, ...data];

  return (
    <div className="sentinel-ticker" data-testid="sentinel-ticker">
      <div className="sentinel-ticker__edge sentinel-ticker__edge--left" />
      <div className="sentinel-ticker__track" ref={trackRef}>
        {items.map((item, i) => (
          <React.Fragment key={i}>
            <div className="sentinel-ticker__item">
              <span className={`sentinel-ticker__dot sentinel-ticker__dot--${item.sentiment}`} />
              <span className="sentinel-ticker__category">{item.category}</span>
              {item.value && <span className="sentinel-ticker__value">{item.value}</span>}
              {item.change && (
                <span className={`sentinel-ticker__change sentinel-ticker__change--${item.sentiment}`}>
                  {item.change}
                </span>
              )}
            </div>
            <div className="sentinel-ticker__divider">&#x25C6;</div>
          </React.Fragment>
        ))}
      </div>
      <div className="sentinel-ticker__edge sentinel-ticker__edge--right" />
      <div className="sentinel-ticker__label">
        <span className="sentinel-ticker__label-icon">&#x25C8;</span>
        <span className="sentinel-ticker__label-text">SENTINEL</span>
      </div>
    </div>
  );
};
